export class PasswordRecoveryConstans {
    public static GrantType = "grant_type";
    public static LoginPath = "/auth";
    public static PasswordRecoveryEmailPath="api/Account/EmailPasswordRecovery"
    public static PasswordRecoveryPath="api/Account/UserChangePassWord"

  }
